<template>
  <div>
    <a v-show="!visit.id" class="text" v-for="i in page" :key="i.id" href="#" @click="set_visit(i)">
      <h2>{{i.title}}</h2>
    </a>

    <p style="white-space: pre-line;" v-show="visit.id">{{visit.content}}</p>
  </div>
</template>
<script>
export default {
  name: 'content-list',
  data () {
    return {
      page: [
        {
          id: 1,
          title: '1.最帅警察父子！相逢在军运会赛场外，他们的这个动作让人鼻酸',
          content: `长江日报-长江网10月24日讯（记者汪伟颋 余康庭）10月24日，快手上一则“父子兵”的视频火了。 

军运赛场外的最帅“父子兵”

视频中，一对父子都穿着警服。父亲看到儿子以后快步走上前，拍了一下儿子的肩膀，又帮儿子扶了扶警帽。“累不累？苦不苦？”“还好！”“行！坚守岗位吧！”说完父亲便匆匆离开，儿子朝着父亲的背影敬了一个礼。

期间，和朱哲元一起执勤的同事帮他们父子拍了一张合影。

视频中的这一幕感动了万千网友，短短十个小时，视频播放量已经超过5000万，超过350万网友点赞，“帅！”“虎父无犬子！”“敬礼的瞬间泪奔！”这对警察父子被网友盛赞为“最帅父子”。


据长江日报-长江网记者了解，视频中穿着特警服装、头戴警盔的是父亲朱宝彦，是孝感公安一巡特警支队二级警长，军运会期间被抽调到公路检查站负责调度工作。儿子朱哲元是武汉公安局硚口分局民警，今年从湖北警官学院毕业后，成为一名交警，军运会期间负责武汉体育中心内场安检和外围安保。

朱哲元毕业以后，两人见面的天数屈指可数。从10月3日至今，朱哲元一直在培训、配合支援地派出所工作，而父亲朱宝彦在6日抵汉之后在军运村执行安保工作。由于各自工作地点距离较远，加上二人在各自的岗位上坚守，因此虽然都在武汉，却已经两周没有见面了。22日这天，巡逻中的朱宝彦恰巧碰上了在路边执勤的儿子，于是出现了画面上的一幕。

“爸爸是我的偶像”

24日，长江日报-长江网记者从朱哲元的QQ空间里看到，他发了一条这样的说说“父子两人，安保一线。执勤异地，使命相同。军运有你我，定能担重托！”

最帅警察父子！相逢在军运会赛场外，他们的这个动作让人鼻酸
 朱哲元的QQ空间截图

朱哲元对长江日报-长江网记者表示，自己知道这段时间父亲在指挥部工作，但没有想到执勤的时候会遇见。“当时看到装甲车停下来，突然看到是爸爸来了，很意外。”对于儿子当天的表现，晚上父亲朱宝彦发来了一条语音，“干得不错”，厚爱无需多言，短短四个字却是父亲对儿子最大的肯定。

能得到父亲的肯定，让朱哲元非常开心，他向长江日报-长江网记者透露，“我当警察就是因为我爸，他执行任务的时候很帅，在外面打击违法犯罪让我非常敬佩”。

提到最后的敬礼，朱哲元这样解释，“应该是本能使然，第一我们在执行任务，不能影响警容风纪；第二我爸衔级比我高，我觉得敬礼是最好的回应”。

军运会结束以后，爸爸朱宝彦就要回到孝感，朱哲元也将继续在武汉工作，“可能短期之内又没法见面了，但有空我一定要回家看看！” 

最帅警察父子！相逢在军运会赛场外，他们的这个动作让人鼻酸
 

来源：受访者提供

动图制作：张莉

责编：申燕伟`
        },
        {
          id: 2,
          title: '2.最特别的“成人礼”： 一家四口献血齐上阵',
          content: `10月24日清晨，一群特殊的献血者兵分三路赶往武汉血液中心。

妈妈李俊带着小儿子的生日蛋糕从蛋糕店匆匆上路，爸爸韩海威和大儿子韩文杰从家中出发，小儿子肖盛辉则和自己的同学老师们从汉口学院专程赶来，九点不到，三支队伍在成分献血科汇合。

父亲韩海威和大儿子韩文杰指导肖盛辉填写体检表

原来，10月24日是小儿子肖盛辉18岁的生日，作为肖盛辉的“成人礼”，李俊韩海威夫妇决定一家四口一起来武汉血液中心参加成分献血。

从李俊2007年第一次在中山公园献血屋献血开始，这个四口之家就与无偿献血结下了不解之缘，李俊12年来献血已经超过百次，丈夫韩海威和大儿子韩文杰也从去年开始献血，韩海威献成分血36次，韩文杰也献了4次……在一家人的爱心感染下，小儿子肖盛辉早早就下定决心，要在自己18岁生日这一天来血液中心献血，送给自己一份特殊的“成人礼”。

让肖盛辉没想到的是，自己的好朋友池俊伟心中也一直有个献血的愿望，刚刚满18岁的他，表示要一起来献血。

在家长、老师和同学们的陪伴下，肖盛辉度过了自己的18岁生日

而更让大家喜出望外的是，在李俊打电话给学校为给小儿子请假来献血时，汉口学院的老师们觉得这件事意义非凡。于是，汉口学院的领导和老师带着两位班干部一起赶过来了：“很多人对无偿献血有一些误解，我们是希望自己来现场了解后，回去通过主题班会、年级大会等形式，对同学们进行无偿献血的知识科普和爱心教育。”

五人集体献血

据了解，一家四口同时进行成分献血在武汉市还是首例。在家人同学和老师的陪伴下，肖盛辉的爱心“成人礼”顺利完成。大家献完血后，唱着生日歌，共同分享了肖盛辉的生日蛋糕，再次为他庆祝这个特别的18岁生日。

文：张宇  图：汪昊

责编：宗晓斌`
        },
        {
          id: 3,
          title: '3.众人撑伞救护老人 盘点正能量爆棚的最美路人',
          content: `众人撑伞救护老人 三四人有的帮撑伞有的提醒车绕行

　　昨日，降雨缓解农田干旱让人欣喜的同时，发生在威海路与桑梓路路口雨中救护摔伤老人的暖心事，也让人心头一热。

　　昨日清晨7时许，记者驾车途经台东时，远远看到威海路与桑梓路路口有一名老人卧在积满雨水的道路上，老人几次试图爬起来，都没能成功。这时旁边走过来一名撑伞的中年妇女，弯腰与老人交谈。此时路口信号灯刚好亮起绿灯，记者立刻将车开过桑梓路，在路口拐角处将车停住，准备过去帮助倒地摔伤的老人。记者走下车时，老人周围已经围了三四名市民，他们有的弯腰给老人撑伞挡雨，有的提醒经过车辆绕行。[page]

　　重庆：15岁女生跪地30分钟 为车祸伤者当靠枕

　　一周前的8月4日下午3点40分左右，涪陵区S103省道北拱火车货运站路段，发生了一起两车对撞的事故。车祸发生后，路过的公交车司机立即停车帮忙，车上的乘客也自发参与救援，其中一名卫校的女生更是用身体为伤者当起了靠枕，引来大家点赞。[page]

　　湖北罗田“最美女孩”跪地施救拾荒老人

　　如果碰到老人昏倒街头，你是救还是不救?3月22日下午2点40分左右，在湖北省罗田县城南新区城南中央街，一名捡破烂的老汉突然昏倒在地不省人事。路过此地的一名年轻女孩见状后，连忙下车跪地给老人按压肺部、人工呼吸进行紧急抢救。女孩对老人进行了近40分钟的抢救，虽然老人不幸离世，但是周围群众对该女孩的这一善举无不交口称赞，称其是“最美女孩”。[page]

　　新娘跪地救人 获网友盛赞“最美新娘”

　　9月21日上午，在大连石槽一海水浴场，一名男子在游泳时突发心脏病不幸溺水，被救上岸时已没有呼吸心跳，在附近拍婚纱照的一位新娘见状，跪地抢救这位陌生男子20多分钟。据了解，新娘子名叫郭嫄嫄，是大连市中心医院心胸乳腺外二科的护士。虽然男子最后不幸身亡，但新娘的行为还是感动了在场的市民，大伙儿称赞她“最美新娘”。小郭的男朋友小刘表示，有小郭这样的女朋友感到很自豪。当时我们俩一起往那儿跑，当得知有心脏病突发的患者时，她跑得比我都快。[page]

　　"90后"土耳其留学生路边救人 脱下白衬衣给伤者止血

　　在翔安南路蔡厝后珩路，一辆中型面包车在调头时，与前面的一辆大货车发生严重追尾事故，面包车车头严重变形。土耳其“90后”小伙唐强正巧路过，他二话不说立即停车救人。昨日，记者辗转联系到了唐强。目前在厦门大学海外教育学院读书的他笑着告诉记者:“我已经成半个厦门人啦。”[page]

　　“托举哥”露面被称“最美路人”

　　6月3日，广州4岁女童琪琪悬挂在4楼阳台，一名男子徒手爬上3楼防盗窗，足足将女童托举了十余分钟。经过众街坊合力营救，女童最后安全着陆，而他却低头走出小区，消失于车水马龙中。经过几天的全城寻找，6月10日，这名救人男子终于出现。

　　他被称为“黄衣男”，也有人叫他“托举哥”，他就是从湖北孝感老家来广州找工作的23岁男子周冲。周冲说，当时正和女友准备到东圃应聘，在路过中山大道怡东苑时，开始出于对围观人群的好奇，在看到女童悬挂高空之后，他义无反顾地爬上防盗窗，做出了“惊人一举”。`
        },
        {
          id: 4,
          title: '4.有GPS，中国为何还要搞北斗？',
          content: `　说起导航，大家都知道GPS，这几乎成了导航的代名词。现在的滴滴打车，各种地图应用，都会用到GPS。

　　问题来了，既然有了GPS，我们中国为什么还要搞北斗呢？

　　要搞清楚这个问题，就要搞清楚，GPS到底是什么。

　　GPS名为全球定位系统，是1958年，美国开启的一个军方项目，一开始是为美国海陆空三军提供情报搜集、核爆监测和应急通讯任务的。

　　所以GPS本质上是一个军用系统，只是后面才开放民用，就算民用，也是要控制的。

　　美国在GPS上加入了信号干扰，人为的降低民用频道的定位精度。

　　直到俄罗斯人搞出了格洛纳斯，美国害怕GPS失去民用市场，这才把信号干扰去掉。

　　但是，民用的GPS还是比不上军用的频道。军用的是毫米级别，民用的分米是分米级别。

　　有了GPS，美军才有可能实行所谓的军事打击，才有了手术刀式的进攻。

　　那么，民用的我们用了GPS，军用的就不用吗？

　　答案显而易用，民间的核心技术都不应该掌握在他人的手里，何况军用。

　　大家都知道华为的例子。

　　在手机操作系统里，除了苹果封闭的OS系统，就是开放的安卓系统。

　　既然安卓是开放的，那就用安卓好了，华为用，小米用，几乎所有中国的手机厂商都在用华为，因为人家说了这是开放的，互联网共享。

　　可是，人家的脸是说变就变的，在年初，美国宣布限制华为。谷歌跟进，宣布将限制华为使用安卓。

　　操作系统是手机的灵魂，没有了操作系统，华为手机不就是铁板一块，生产出来的手机怎么办？华为的生产线怎么办，华为的数万员工怎么办？给华为配套的数十万人的生计怎么办。

　　关键时刻，华为拿出了自己的鸿蒙系统。

　　早在数年前，安卓大打开放牌的时候，华为就在研究操作系统了。

　　难怪商界才说，任正非是一个极具危机意识的企业家。

　　在看到华为的鸿蒙系统时，谷歌突然改变态度，允许华为继续使用安卓。

　　这就是商业法则，你要想顺利使用别人的东西，你就得有自己的东西，你越有的东西，人家越要让你用。你越没有的东西，人家就掐着脖子不让你用。

　　有时候，限制并不可怕，可怕的是自己在开放面前失去了危机意识。

　　像电脑操作系统，中国现在还没有开发出来大众可以用的操作系统，就是因为微软给中国提供使用。

　　幸亏随着移动技术的存在，电脑已经不是最前沿的东西了。不然，美国突然说不让联想用WINDOW系统，联想的电脑还能卖得出去吗？

　　这是华为的例子，民用如此，军用就更加了。

　　其实军用也有一个鲜活的例子。这就是印度。

　　印度的武器一直使用美国的GPS，用着挺好，省钱还方便。

　　但关键时刻掉链子了，在印巴冲突中，美国突然关掉了印巴区域的GPS服务。

　　印度跟巴基斯坦的武器一下成了瞎子，变成了烧火棍，巴基斯坦还好说，他原本武器比印度差。大家都不开GPS，巴斯斯坦可能还得了便宜。

　　印度受不了，自己跟美国买了那么多先进的武器，结果到了关键时刻，你把准星拔了，这钱不白花了？

　　何况正在占上风，你突然在后面使了一个绊。

　　从那之后，印度就正式放弃了GPS，搞自己的卫星系统，没钱也要上，发射卫星常常出问题，也要上。就是因为被掐过脖子。

　　当然，印度钱不够，搞不了全球的，只好搞了一个南亚版本的，在南亚用自己的，然后全球范围内还用GPS的。

　　印度都要搞，我们中国当然更要搞。

　　而且我们也吃过一次亏。

　　1993年，我们国家一号货轮正在海面上行驶。美国突然说我们的船上有化学武器。要上船 搜查。

　　大家知道，船只是一个国家的离岸国土，是不允许别国擅自闯入的，何况是军事单位。

　　可是，我们的船开着开着，就不得不停了下来。因为美国把船只所在区域的GPS导航服务关闭了。

　　此后，我们的这条船在海上飘了三十三天，损失惨重。

　　所以，没有自己的定位系统，那鼻子就等于被别人牵在手里。

　　我们搞，技术来源就是一个问题，苏联人搞，他不带我们。

　　后面欧洲人搞伽利略系统，我们赶紧上前合作，掏2亿美金。

　　结果搞了半天，进展缓慢，毕竟欧洲跟美国近，用GPS也能行，他们紧迫感不强。何况欧盟各国还爱扯皮。

　　二来，我们只能在旁边打下手，真正的核心技术还是不会告诉我们的。

　　我们原本希望跟印度一样，本区域的用自己的，全球用欧洲的伽利略系统。但看来，这条路也不行，那就干脆自己搞。

　　2007年，中国开始构建自己的北斗系统，到了2012年，我们完成了第一步，发射16颗卫星，覆盖亚太地区（覆盖全球至少需要24颗）

　　到明年，中国将总共发射35颗卫星，实现全球联网。

　　可以说，明年最大的一件事情就是北斗正式全球联网。

　　而在这之前，北斗导航早已经开始在我们的身边应用了。

　　大家的手机上，其实就有不少使用北斗信号的，只是大家不知道。

　　北斗相比GPS，因为有后发优势，所以在某些技术上还处在领先地位。

　　比如我们的北斗具有短报文系统。

　　其它的定位系统只能单向联系，而北斗系统具有双向联系的功能，也就是可以向外界发送消息，这等于多了一个通信功能，这在手机信号不好的时候，特别的管用。

　　像汶川地震的时候，北斗就发挥了通信的作用。

　　再比如在海洋上碰到事情，GPS只能帮你找到你自己的位置，如果想让别人找到你，又没有信号的时候，那就没招了。而用北斗就不同了，一个信号发出去，救援就来了。

　　目前来说，北斗定位系统的民用前景不如GPS广泛，毕竟人家布局了三十年，但北斗有它的优势，尤其是有中国这么大的人口基数，是完全可以撑起北斗定位系统应用的。

　　而北斗系统的研发过程中，最为国人熟知的竟然是一起破译事件。

　　十年前，一位清华的毕业生到美国斯坦福大学攻读EE博士，其间破解了北斗卫星导航系统的编码程序。

　　美国RTCA（航空无线电委员会）特地给她颁发了W.E.Jackson奖。

　　当时新闻的标题很吓人，比如卖国，比如让北斗一千多亿的投资打了水漂。

　　其实这里面有真有假，比如她确实在清华接触过北斗项目，这也是她被斯坦福大学录取的原因之一。在国内得到的资料也确实对她破译编程有帮助。

　　这位学生跑到美国，有很多工作可以做，却独独选择破解北斗的编码，这从选择上就不是特别聪明。因为2007年，我们还为她颁发了“国家优秀自费留学生奖学金”，奖金是5000美金。

　　出了国，就开始研究中国的秘密，然后告诉外国人，这样做，使她以前的同学包括老师非常被动。

　　另外，让北斗千亿投资打水漂就有些夸张了。因为她的破解其实并没有太大的危害。

　　因为她破解的编码，是北斗的民用段，民用段本来就是给大家用的，比如大家的地图可以用这个民用段来导航，所以设计之初就跟GPS等系统有关联性，破解是有方法的。

　　在今年 ，我们就公布了这个编码规则。所以她的破解说不上危害有多么大。只是在我们公布之前，她通过一些资料能够“猜”出来，确实比较厉害。

　　那她有没有可能猜出我们的军用段呢？如果这个也猜出来，我们的北斗系统就比较麻烦了。

　　这个担忧也是不必要的。

　　中科院光电研究院的徐颖就专门做了一个介绍。

　　徐颖是北京大学的毕业生，毕业后开始接触北斗相关项目的研究，在2009年，那位清华学子在海外靠破译北斗编码获奖的时候，徐颖进入中国科学院，成为了中国科学院光电研究院建院以来最年轻的博士生导师。此后一直从事北斗相关项目的研究。被称为北斗女神。

　　对于清华女生的北斗事件，她有一个权威的解释。

　　“北斗系统从诞生到现在，虽然已经通过多方面证明，精度和可靠性，完全不输GPS导航系统，但是人们对北斗系统有着种种质疑。

　　这是网上大概2011年左右传得比较沸沸扬扬的新闻，当时媒体使用的标题是“清华女生破解北斗送给美国”，或者是“北斗上百亿的投资打水漂”等等，

　　比较耸人听闻。那么北斗真的如此不堪一击吗？

　　当然不是。

　　事实上真正不可靠的是GPS系统。因为GPS系统只被我们开放了民码，而且GPS民码信号战争时候很容易说变就变，为了保障自主权，欧盟建设了伽利略系统。对我们来讲也是如此，为了保障我们的可靠性，我们国家开始建设属于我们自己的北斗系统。

　　我们回到清华女生破解北斗这个新闻上，实际上她只是破译了北斗的民码信号的伪码序列。

　　首先第一点，北斗建设过程当中，民码的设计和GPS、伽利略都是一脉相承的，并没有特殊设计。

　　我国希望全世界人民都能使用北斗，不仅是中国的北斗，也是世界的北斗。她想破解这个没有经过加密的民码信号，首先是没有技术难度的。从科学研究的角度来讲就是一个信号检测与估计的问题。

　　事实上2012年的时候，我们国家已经公布了北斗的ICD文件，告诉了大家我们的民码格式。除了民码之外，北斗还有军码，军码经过了加密等特殊设计等，这是稳定可靠的。

　　如果想破解军码系统，我们可能建议一些更简单的方式。那就是造时空穿越机穿越回到北斗军码设计的时候在旁边偷听好了。这个技术难度都比从技术上来破解北斗军码更容易一些。

　　所以，大家要相信我们北斗系统非常好用，而且非常稳定的。

　　作为一个卫星导航的普通科研工作者，我们相信北斗这一艘巨轮在大家支持下，在我们的不懈努力下一定可以继续乘风破浪走向世界，谢谢大家。”

　　造时空穿越机这个建议太霸气了。

　　所以，北斗不会因为一个人的破解而打水漂，只是这件事情给我们提了一个醒，现在中国有很多高校的学生出国，他们出国时，有没有涉及比较机密的东西，出国后，怎么尽量避免在这方面的泄露。

　　当然，最终还是要回到自身强大上来，中国要形成一个科学家集群方阵，在将来要涌现海量的科学家，这样就算出现漏洞，也能有相应的手段。

　　现在我们从小学就开始开设科学课程，把科学课放到了跟语文数学同样重要的位置。就是希望中国能够培养出越来越多的科学家。

　　但是科学课刚开，我们好多学校其实并没有科学课经验，有的甚至是别的科目老师代替上。

　　其实科学课对老师的综合素质要求最高，科学课老师真的是要求上知天文，下知地理。什么都要会，偏偏我们在科学课上的积累几乎为零。

　　这导致学校不知道怎么上。像我的小孩今年上六年级，科学课就基本是死记硬背，这样就违背了科学课的初衷，小学科学课的目标不在于记多少知识点，而是怎么培养科学的兴趣。

　　蒋柳，文史作家，历史自媒体“脑洞历史观”主笔，头条学院讲师，国学文化专业委员会副秘书长，倡导打开脑洞看历史。著有《读懂春秋，就懂了当下》《诸王的游戏》《隋唐不演义》《唐末刀锋汇》等。其自媒体“脑洞历史观”，拥有百万订阅，阅读达二十亿人次。`
        },
        {
          id: 5,
          title: '5.新版人民币如何"神秘"设计的？钞票设计师告诉你',
          content: ` 新华社北京10月24日电 题：来看看他们如何设计“中国名片”？——探访新版人民币的钞票设计师

    新华社记者 吴雨

    设计师这个职业你一定不陌生，但是你了解钞票设计师吗？作为“中国名片”的设计师，他们的工作极具挑战，设计的“产品”受众面最广、使用率最大、关注度最高。日前，新华社记者走进中国印钞造币总公司下属中钞研究院，听钞票设计师们讲述他们与人民币的故事。

    “神秘”的设计、特别的“产品”

    “成为设计师可能是不少美术类院校毕业生的必然道路，但设计钞票却是我从未想过的。”聊起自己成为钞票设计师的经历，于欣充满感慨。2002年从清华美院毕业的他，此前从没想过会成为“万里挑一”的钞票设计师。而带他走进这个神秘行业的，正是当时中国钞票设计领域领军人物、中国印钞造币总公司原技术总监邵国伟。

    作为第五套人民币100元的主设计师，邵国伟的一句话打动了前来应聘的于欣：为国家设计“名片”充满着荣誉感和成就感，会使你一生充满意义。

    正是这份荣誉感激励着一代又一代钞票设计师默默付出，深藏功与名。和于欣一样，越来越多从美术院校毕业的专业人才怀揣着满腔抱负进入中国印钞造币总公司。目前，于欣所带领的设计师团队平均年龄36岁，团队90%的设计师有着扎实的专业美术背景。

    设计师团队里的郑可新告诉记者，设计“国家名片”既要考虑到钞票的识别功能和防伪功能，又要将传统艺术和当代艺术相结合，还要展示出一国的科技水平。钞票并非普通的设计作品，需要接受大众的审视，靠一腔热情和象牙塔里的知识远远不够。

    “并不是每个进入钞票行业的设计师，都能立马接触到钞票设计，大多数人要经过漫长的学徒阶段。”于欣告诉记者，从入行后设计纪念币、纪念钞，再到主导新版人民币设计，他经历了七八年的学徒生涯。一切关于钞票设计的方法要领都要从行业前辈那里获取，在工作中一点一滴地累积。

    精细化的计算机辅助、更国际化的视野

    功夫不负有心人。2017年冬，中国人民银行准备发行2019版第五套人民币，中国印钞造币总公司全力部署设计开发工作。在于欣入行的第15个年头，重任交到了他和他的团队肩上。

    “作为一名钞票设计师，能够在有限的职业生涯中，为人民币做一次设计，机会非常难得。”于欣说，尽管此次新版人民币主要做了一系列提升优化，但其实比设计新系列难度更大。

    设计师孙健告诉记者，设计师的想法天马行空，但在钞票设计中必须把发散的理念收回来，做出适合公众审美和使用的“产品”。一方面要保持第五套人民币原来的设计风貌，另一方面要给公众焕然一新的感受，留给设计师可发挥的空间相对有限。

    不过，日臻完善的计算机辅助设备和不断提升的印刷设备，正带给设计师们更多的灵感空间：数字光彩光变、图像“微缩”防伪、加大水印尺寸、底纹不规则变化……

    于欣告诉记者，计算机辅助设计解决了很多手绘设计的问题，修改、调整、制版的效率大大提高。人民币设计开始国际化，拥有更高辨识度的色彩、更加精细化的图纹、更先进的防伪设计。

    其实，在设计1999版第五套人民币100元时，我国已经开始应用自行开发的计算机辅助设计软件进行原版制作。但当时软件漏洞较多，设计过程中多次遇到在关键时刻软件“死机”的情况。

    “现在利用更先进的技术辅助，我们可以加入更为先进的防伪手段，融入更多科学性设计，新版人民币在功能性、防伪性等方面得到了明显提升。”于欣说。

    我国钞票设计加速走上国际舞台

    作为“国家名片”，钞票不仅仅是支付工具，更浓缩了重要的政治、经济、文化信息。中国印钞造币总公司技术总监刘永江告诉记者，从第一套到第五套，人民币的样子在变，人民的日子也在变。人民币变迁的背后，是综合国力的腾飞，浓缩的是国家自信。

    人民币在国际舞台上扮演越来越重要角色的同时，我国的印钞造币水平也逐渐在国际市场上崭露头角。

    早在20世纪70年代，我国曾为老挝、越南、柬埔寨等国家提供过钞票印制援助。近年来，中国的钞票设计师们将更多视野投向国际，逐鹿“一带一路”沿线的国际商业印钞造币市场。我国设计师多次中标国际项目，并斩获多个国际印钞大奖。

    “与老牌国际造币企业同台竞技，我国的钞票设计、印制能力得到不断淬炼。现在中国的钞票设计师已成为世界钞票设计师协会的重要成员。”于欣说，通过加强国际交流，不仅能将世界最先进的防伪技术、设计理念为我所用，更把我国的印钞造币服务推向国际市场。`
        }
      ],
      visit: {}
    }
  },
  destroyed () {
    console.log(1)
  },
  methods: {
    set_visit (i) {
      this.visit = i
    },
    reset () {
      this.visit = {}
    }
  }
}
</script>
<style lang="scss" scoped>
.text {
  text-decoration: none;
  color: black;
}
</style>
